module.exports = __webpack_public_path__ + "static/media/dicas-de-decoracao-diy-para-voce-fazer-e-decorar-sua-casa.010d21dc.jpg";